import React from 'react';

type STATE = {
  hiddenItems: any[],
  haveVisibleItems: boolean,
  haveHiddenItems: boolean,
  items: []
};

export type WRAPPER = {
  getState: () => STATE,
  getItems: () => any[],
  context: any,
  style: {flexWrap: 'nowrap'}
};

function withOverflowMenu(WrappedComponent: any) {
  return class extends React.Component<any, STATE> {
    childRef: any;

    constructor(props: any) {
      super(props);
      this.childRef = React.createRef();
      this.state = {
        hiddenItems: [],
        items: [],
        haveVisibleItems: false,
        haveHiddenItems: false

      };
    }

    componentDidMount() {
      this.setToolbarLayout();
    }

    static getDerivedStateFromProps(props: any) {
      return {
        items: props.items,
        haveVisibleItems: false,
        haveHiddenItems: false,
        hiddenItems: []
      };
    }

    /**
     * Rebuild toolbar on resize to obtain the width of resized toolbar
     */
    onResize() {
      this.setState({
        items: this.props.items,
        haveVisibleItems: false,
        haveHiddenItems: false,
        hiddenItems: []
      }, () => this.setToolbarLayout());
    }

    /**
     * Calculate the number of toolbar items that can fit into toolbar
     * and place them in corresponding state e.g. visible/hidden items
     */
    setToolbarLayout: () => void = () => {
      const items = this.props.items;
      const childRef = this.childRef.current;

      let hiddenItems: any[] = [];
      let haveVisibleItems = false;
      let haveHiddenItems = false;

      if (childRef) {
        const toolbarEl = childRef.element;
        hiddenItems = [];
        haveVisibleItems = true;

        let current;
        let item = 0;
        let toolbarOffsetWidth;
        let widthResult;
        let toolbarOffsetHeight;
        let heightResult;

        while (item < items.length) {
          current = childRef.element.children[item];
          const isLeftPosition = this.detectToolbarPosition(current, toolbarEl);

          if (isLeftPosition) {
            toolbarOffsetWidth = toolbarEl.offsetWidth + toolbarEl.offsetLeft - 2 * current.offsetWidth;
            widthResult = current.offsetLeft < toolbarOffsetWidth;
            if (current.offsetLeft < (toolbarEl.offsetWidth + toolbarEl.offsetLeft - 2 * current.offsetWidth)) {
              current.dataset['visibleComponent'] = widthResult;
            } else {
              hiddenItems.push(React.cloneElement(items[item]));
              current.dataset['visibleComponent'] = widthResult;
              haveHiddenItems = !widthResult;
            }
          } else {
            const offsetRight = toolbarEl.offsetWidth - (current.offsetLeft + current.offsetWidth);
            toolbarOffsetHeight = toolbarEl.offsetWidth + toolbarEl.offsetLeft - 2 * current.offsetWidth;
            heightResult = offsetRight < toolbarOffsetHeight;

            if (heightResult) {
              current.dataset['visibleComponent'] = heightResult;
            } else {
              hiddenItems.push(React.cloneElement(items[item]));
              current.dataset['visibleComponent'] = heightResult;
              haveHiddenItems = true;
            }
          }

          item++;
        }
      }

      this.setState((prevState: STATE) => ({
        ...prevState,
        hiddenItems,
        haveVisibleItems,
        haveHiddenItems
      }));
    };

    detectToolbarPosition = (current: any, toolbarEl: any) => current.offsetWidth + current.offsetLeft === toolbarEl.offsetWidth;

    /**
     * Get state values
     */
    getState: () => STATE = () => this.state;

    /**
     * Initially return all items
     * After the calculations are done return only visible items
     */
    getItems: () => any[] = () => this.props.items;

    /**
     * API exposed to the wrapper component
     * Accessed via this.props.toolbar...
     */
    OVERFLOWING_WRAPPER: WRAPPER = {
      getState: this.getState,
      getItems: this.getItems,
      context: this,
      style: { flexWrap: 'nowrap' }
    };

    render() {
      return (
        <WrappedComponent 
          {...this.props}
          toolbar={this.OVERFLOWING_WRAPPER}
          onResize={this.onResize.bind(this)}
          innerRef={this.childRef}
        />
      );
    }
  };
}

export default withOverflowMenu;
